export const sizes = {
  baseHalf: "4px",
  baseSingle: "8px",
  baseDouble: "16px",
  baseTriple: "24px",
  baseQuadric: "32px",
  basePenta: "40px",
  baseSix: "48px",
  baseSepta: "56px",
  baseOcto: "64px",
  baseDeca: "80px",
  /* Gaps */
  gap: "16px",

  desktop: {},
  maxWidthContainer: "1560px",
  maxWidthContainerXl: "1880px",
  /* Font Sizes */
  fonts: {
    h1: "28px",
    h2: "28px",
    h3: "15px",
    h4: "17px",
    body: "14px",
    search: "17px",
    button: "16px",
    desktop: {
      h1: "28px",
      h2: "28px",
      h3: "15px",
      h4: "17px",
      body: "14px",
      search: "17px",
      button: "18px",
    },
  },
  /* Border radiuses */
  radius: {
    small: ".3em",
    medium: "1em",
    large: "2em",
    circle: "3em",
  },
  borderRadius: "20px",
  borderRadiusLarge: "30px",
  borderRadiusTriple: "60px",
  /* Elements sizes */
  icon: {
    desktop: {},
  },
  arrow: {
    desktop: {},
  },

  /* Components sizes */
  BlockWrapper: {
    mobile: {
      paddingTop: "56px",
      paddingLeft: "24px",
      gap: "33px",
      marginTop: "-15px",
    },
    desktopM: {
      padding: "120px",
      gap: "50px",
      marginTop: "-60px",
    },
    desktop: {
      padding: "120px",
      gap: "50px",
      marginTop: "-60px",
    },
    desktopXl: {
      gap: "50px",
      padding: "90px",
    },
  },

  ErrorPages: {
    desktop: {
      paddingHorizontal: "180px",
      gap: "50px",
      marginTop: "-60px",
    },
    mobile: {
      paddingHorizontal: "24px",
    },
  },
}
